import { RavelElement } from '../../ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelSignal extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #icon {
            font-size: 32px;
            margin: 5px;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="icon"></div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        // e.g. this.icon = this.shadowRoot.querySelector('#icon');
    }
  
    setup = () => {
        this.observedMessages = [];
        //this.subscribe(this.observedMessages);   
        this.shadowRoot.querySelector('#icon').innerHTML = `${this.icon}`;
    }
    
    teardown = () => {
       // this.unsubscribe(this.observedMessages);
    }

    getIcon = () => {
        return this.icon;
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        // Element doesn't have any for now
        super.attributeChangedCallback(name, oldValue, newValue);
        
    }
}

